import { schema } from 'normalizr';

import { processGroupCoverImage } from '../strategies/groupCoverImage';

export const groupCoverImageSchema: schema.Entity = new schema.Entity(
  'groupCoverImages',
  {},
  { processStrategy: processGroupCoverImage }
);

export type GroupCoverImageEdgesSchema = typeof groupCoverImageEdgesSchema;
export const groupCoverImageEdgesSchema: schema.Object[] = [new schema.Object({ node: groupCoverImageSchema })];
